module.exports = "<span>{{ data }}</span>";